var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4008 7.38461C15.8984 7.38461 17.7758 6.40814 18.8937 5.10617C19.9062 3.92625 20.6445 2.27845 20.6445 0.630641C20.6445 0.406865 20.6234 0.18309 20.5812 0C18.9148 0.0610299 16.9109 1.07819 15.7086 2.44119C14.7594 3.4787 13.8945 5.10617 13.8945 6.77432C13.8945 7.01844 13.9367 7.26256 13.9578 7.34393C14.0633 7.36427 14.232 7.38461 14.4008 7.38461ZM9.12734 32C11.1734 32 12.0805 30.6777 14.6328 30.6777C17.2273 30.6777 17.7969 31.9593 20.075 31.9593C22.3109 31.9593 23.8086 29.9657 25.2219 28.0127C26.8039 25.775 27.4578 23.5779 27.5 23.4762C27.3523 23.4355 23.0703 21.747 23.0703 17.007C23.0703 12.8976 26.4453 11.0464 26.6352 10.904C24.3992 7.81182 21.0031 7.73045 20.075 7.73045C17.5648 7.73045 15.5187 9.19517 14.232 9.19517C12.8398 9.19517 11.0047 7.81183 8.83203 7.81183C4.69766 7.81183 0.5 11.1074 0.5 17.3325C0.5 21.1977 2.06094 25.2867 3.98047 27.9313C5.62578 30.1691 7.06016 32 9.12734 32Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d3e21049cee8194110bac8c4b40d3d15.svg";
export { ForwardRef as ReactComponent };